<div id="cover" *ngIf="projectService.loading()"></div>

<div class="page-shell" *ngIf="commonDataObject.selectedProject">
    <aside class="info-card">
        <div class="info-card__header">
            <div class="proj-row">
                <div class="proj-icon-wrap">
                    <i class="fas fa-diagram-project"></i>
                </div>
                <div>
                    <h2 class="proj-name">{{ commonDataObject.selectedProject?.project_name }}</h2>
                </div>
            </div>
        </div>
        <div class="info-card__meta">
            <div class="meta-row">
                <div class="meta-ico"><i class="fas fa-user-check"></i></div>
                <div class="meta-body">
                    <span class="meta-lbl">Coordinator</span>
                    <span class="meta-val">{{ commonDataObject.selectedProject?.project_coordinator || '—' }}</span>
                </div>
            </div>
            <div class="meta-row">
                <div class="meta-ico"><i class="fas fa-user-friends"></i></div>
                <div class="meta-body">
                    <span class="meta-lbl">Co-Coordinator</span>
                    <span class="meta-val">{{ commonDataObject.selectedProject?.project_co_coordinator || '—' }}</span>
                </div>
            </div>
        </div>
        <div class="info-card__desc">
            <div class="desc-lbl"><i class="fas fa-align-left"></i> Description</div>
            <p class="desc-box" [title]="commonDataObject.selectedProject?.project_description">
                {{ commonDataObject.selectedProject?.project_description || 'No description provided.' }}
            </p>
        </div>
        <div class="info-card__expense">
            <div class="expense-chip">
                <i class="fas fa-coins"></i>
                <div>
                    <span class="exp-lbl">Overall expense</span>
                    <span class="exp-val">
                        ₹ {{ expenseApiData?.calculated_overall_expense
                        ? (expenseApiData?.calculated_overall_expense | number:'1.2-2')
                        : '—' }}
                    </span>
                </div>
            </div>
        </div>
    </aside>
    <section class="data-section">
        <div class="panel panel--top">
            <div class="info-card__toggle">
                <span class="toggle-hint">View mode</span>
                <div class="toggle-group">
                    <button type="button" class="toggle-btn" [class.active]="viewMode === 'chart'"
                        (click)="toggleViewMode('chart')">
                        <i class="fas fa-chart-pie"></i> Chart
                    </button>
                    <button type="button" class="toggle-btn" [class.active]="viewMode === 'table'"
                        (click)="toggleViewMode('table')">
                        <i class="fas fa-table-cells"></i> Table
                    </button>
                </div>
            </div>
            <div class="panel__body" *ngIf="viewMode === 'table'">
                <div class="tbl-scroll">
                    <table class="data-table">
                        <thead>
                            <tr>
                                <th>Form name</th>
                                <th class="tc">Total forms</th>
                                <th class="tr">Expense (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of tableData">
                                <td>{{ item.form_name }}</td>
                                <td class="tc">
                                    <span class="pill pill-b">{{ item.total_forms_filled }}</span>
                                </td>
                                <td class="tr">₹ {{ item.expense | number:'1.2-2' }}</td>
                            </tr>
                            <tr *ngIf="!tableData.length">
                                <td colspan="4" class="empty-row">No records found</td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="tableData.length">
                            <tr class="total-row">
                                <td></td>
                                <td class="tc"><strong>{{ getTotalForms() }}</strong></td>
                                <td class="tr"><strong>₹ {{ getTotalExpense() | number:'1.2-2' }}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="panel__body chart-body" *ngIf="viewMode === 'chart'">
                <div class="chart-tabs">
                    <button class="tab-btn" [class.active]="activeChartType === 'expense'"
                        (click)="setChartType('expense')">
                        <i class="fas fa-chart-bar"></i> Yearly expense
                    </button>
                    <button class="tab-btn" [class.active]="activeChartType === 'forms'"
                        (click)="setChartType('forms')">
                        <i class="fas fa-chart-pie"></i> Form-wise
                    </button>
                </div>
                <div class="chart-container">
                    <div *ngIf="activeChartType === 'forms'">
                        <ng-container *ngIf="chartData.formWise?.labels?.length > 0; else noChart">
                            <p-chart type="doughnut" [data]="chartData.formWise" [options]="chartOptions"
                                [style]="{ height: 'auto', width: 'calc(100vh - 34vh)' }">
                            </p-chart>
                        </ng-container>
                    </div>
                    <div *ngIf="activeChartType === 'expense'">
                        <ng-container *ngIf="chartData.yearWiseExpense?.labels?.length > 0; else noChart">
                            <p-chart type="doughnut" [data]="chartData.yearWiseExpense" [options]="chartOptions"
                                [style]="{ height: 'auto', width: 'calc(100vh - 34vh)' }">
                            </p-chart>
                        </ng-container>
                    </div>
                    <ng-template #noChart>
                        <div class="no-data">
                            <i class="pi pi-chart-line"></i>
                            <p>No chart data available</p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="panel panel--bottom">
            <div class="panel__hd">
                <span class="panel__title">
                    <i class="fas fa-calendar-days"></i> Year-wise expense
                </span>
            </div>
            <div class="panel__body">
                <div class="tbl-scroll">
                    <table class="data-table">
                        <thead>
                            <tr>
                                <th>Year</th>
                                <th class="tr">Expense (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getOverallExpenseData(); let i = index">
                                <td>{{ item.key }}</td>
                                <td class="tr">₹ {{ item.value | number:'1.2-2' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</div>